import { Button, Input, Select } from 'antd';
import React, { FunctionComponent } from 'react';
import css from './GamesListHeader.module.less';
import componentContent from './GamesListHeader.content.json';
import useTranslate from '@hooks/useTranslate';
import { PlusOutlined } from '@ant-design/icons';
import { openModal } from '@stores/modals';
import games, { getList, filters } from '@stores/games';
import { useStore } from 'effector-react';
import localeWeightStore, { localeWeightMap, setLocaleWeight, LOCALE } from '@stores/localeWeight';
import useGuards from '@hooks/useGuards';

const { Option } = Select;

interface GamesListHeaderProps {}

const GamesListHeader: FunctionComponent<GamesListHeaderProps> = () => {
  const content = useTranslate(componentContent);
  const currentFilterParams = useStore(filters);
  const { defaultFilters } = useStore(games);

  const localeName = useStore(localeWeightStore);
  const { allowChange } = useGuards();
  const onSearch = (filter: string) => {
    const { sort } = defaultFilters;
    getList({
      filters: {
        sort: filter ? '' : sort,
        filter,
      },
    });
  };

  const onChangeLocale = (newLocale: LOCALE) => {
    setLocaleWeight(newLocale);
    getList({ filters: { ...currentFilterParams } });
  };

  return (
    <div className={css.root}>
      <div className={css.search}>
        <Input.Search
          placeholder={content.search}
          onSearch={onSearch}
          allowClear
        />
      </div>
      {allowChange ? (
        <Button
          type='primary'
          icon={<PlusOutlined />}
          onClick={() => openModal({ name: 'game' })}
        >
          {content.add}
        </Button>
      ) : null}
      <Select
        defaultValue={localeName}
        style={{ width: 120 }}
        onChange={onChangeLocale}
      >
        {localeWeightMap &&
          Object.entries(localeWeightMap).map(([key, value]) => {
            return (
              <Option
                value={key}
                key={key}
              >
                {value.name}
              </Option>
            );
          })}
      </Select>
    </div>
  );
};

export default GamesListHeader;
